import { render, staticRenderFns } from "./FarmLandData.vue?vue&type=template&id=7f19bd10&scoped=true&"
import script from "./FarmLandData.vue?vue&type=script&lang=js&"
export * from "./FarmLandData.vue?vue&type=script&lang=js&"
import style0 from "./FarmLandData.vue?vue&type=style&index=0&id=7f19bd10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f19bd10",
  null
  
)

export default component.exports